// Categories data - images are fetched dynamically from the PHP backend
// This allows changing images in the backend/public/assets/prodotti/{category}/ folders
// without needing to rebuild the React app

const categories = {
  finestre: {
    title: "Finestre",
    description:
      "Finestre in legno, PVC e alluminio sia a giunto aperto che a taglio termico di qualsiasi dimensione, tipologia e colore e con qualsiasi tipo di vetro. Le nostre finestre garantiscono isolamento termico e acustico superiore.",
    features: [
      "Finestre in legno massello",
      "Finestre in PVC a taglio termico",
      "Finestre in alluminio con vetro camera",
      "Personalizzazione colori e dimensioni",
      "Doppi e tripli vetri",
    ],
  },
  porte: {
    title: "Porte",
    description:
      "Porte interne ed esterne in massello, impiallacciate, laminate o in alluminio, corredate anche di vetrate artistiche. Porte blindate anche con recupero del pannello esistente per garantire la massima sicurezza.",
    features: [
      "Porte interne in massello",
      "Porte blindate certificate",
      "Portoni condominiali",
      "Porte scorrevoli e a battente",
      "Recupero pannello esistente",
    ],
  },
  tende: {
    title: "Tende e Schermature",
    description:
      "Tende da sole, tende a rullo, veneziane, avvolgibili e zanzariere. Persiane a stecca fissa, con gelosia, con stecca orientabile sia in alluminio, che in PVC che in legno che in ferro blindate.",
    features: [
      "Tende da sole con struttura robusta",
      "Tende a rullo per interni",
      "Veneziane in alluminio",
      "Avvolgibili e zanzariere",
      "Persiane orientabili",
    ],
  },
  altro: {
    title: "Altri Prodotti",
    description:
      "Vetrine per negozi, cancelli, inferriate e ringhiere in ferro battuto anche su Vostro disegno. Verande per chiusura terrazzi, serre e tettoie. Soluzioni personalizzate per ogni esigenza.",
    features: [
      "Vetrine per negozi",
      "Cancelli in ferro battuto",
      "Inferriate di sicurezza",
      "Verande e serre",
      "Tettoie e coperture",
    ],
  },
};

export default categories;
